export const FRONTEND_STATE_SET_MY_LOCATION = 'FRONTEND_STATE_SET_MY_LOCATION';
export const FRONTEND_STATE_ENABLE_LOCATION_TRACKING = 'FRONTEND_STATE_ENABLE_LOCATION_TRACKING';
export const FRONTEND_STATE_DISABLE_LOCATION_TRACKING = 'FRONTEND_STATE_DISABLE_LOCATION_TRACKING';
export const FRONTEND_STATE_LOCATION_TRACKING_ERROR = 'FRONTEND_STATE_LOCATION_TRACKING_ERROR';
